<template>
	<div class="c-wrap n-mb-3">
		<div class="news-search js--news-main-search">
			<div class="n-marquee js--marquee n-mb-3 n-mb-md-0" style="width: 100%">
				<div class="n-marquee__strip" v-if="marque">
					<template v-for="(item, index) in marque" :key="index">
						<span class="n-marquee__item">
							<span class="n-marquee__property"></span>
							<span
								:class="'n-marquee__value n-marquee__value_' + item.arrow_1"
							>
								{{ item.bold_text_1 }}
								{{ item.bold_text_2 }}
							</span>

							<span
								:class="'n-marquee__value n-marquee__value_' + item.arrow_2"
								v-if="item.bold_text_3 || item.bold_text_4"
							>
								{{ item.bold_text_3 }}
								{{ item.bold_text_4 }}
							</span>
						</span>
					</template>
				</div>
			</div>
			<form class="news-search__wrap" action="/media/news/search/">
				<label class="input input_search is-empty js--search">
					<button class="input__search-btn search-button"></button>
					<input
						class="input__field"
						type="search"
						placeholder="Введите запрос"
						name="q"
					/>
					<button class="input__clear-btn input__clear-btn_text" type="button">
						Сбросить
					</button>
				</label>
			</form>
			<button class="news-search__icon">
				<svg
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M3 9C3 5.68629 5.68629 3 9 3C12.3137 3 15 5.68629 15 9C15 12.3137 12.3137 15 9 15C5.68629 15 3 12.3137 3 9ZM9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17C10.8487 17 12.551 16.3729 13.9057 15.3198L17.2929 18.7071L18.7071 17.2928L15.3199 13.9056C16.3729 12.5509 17 10.8487 17 9C17 4.58172 13.4183 1 9 1Z"
						fill="white"
					></path>
				</svg>
				<svg
					width="20"
					height="20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M3 17 17 3M17 17 3 3" stroke="#fff" stroke-width="2"></path>
				</svg>
			</button>
		</div>
	</div>
	<section>
		<div class="c-wrap news-margin">
			<div class="n-row js--max-height-wrapper">
				<!-- Новости -->
				<div class="n-col-lg-12 n-mb-6 n-mb-lg-0">
					<div class="js--max-height-example news-main-preview__wrapper">
						<div class="news-banner n-mb-2 n-mb-lg-3">
							<picture>
								<source
									srcset="/static/dist/v2/img/news-fresh_mobile.jpg"
									media="(max-width: 767px)"
								/>
								<source
									srcset="/static/dist/v2/img/news-fresh_tablet.jpg"
									media="(max-width: 1123px)"
								/>
								<img
									class="news-banner__image"
									src="/static/dist/v2/img/news-fresh.jpg"
									:alt="JSON.parse(data).items[0].title"
									loading="lazy"
								/>
							</picture>
							<div class="news-banner__content">
								<span class="news-banner__type">Последние новости</span>
								<span class="news-banner__title">{{
									JSON.parse(data).items[0].title
								}}</span>
								<p class="news-banner__description"></p>
							</div>
							<a
								class="link-full-block"
								:href="JSON.parse(data).items[0].url"
							></a>
						</div>
						<div class="n-news-list-wrap-hider n-row n-mb-n2 n-mb-lg-n3">
							<template v-if="data">
								<template
									v-for="(item, index) in JSON.parse(data).items"
									:key="index"
								>
									<div
										class="n-col-24 n-col-md-12 n-mb-2 n-mb-lg-3"
										v-if="index !== 0"
									>
										<div class="n-news-list">
											<div class="n-news-list__main">
												<div class="n-news-list__category category">
													<time class="category__text" :datetime="item.date">{{
														item.time
													}}</time>
												</div>
												<h3 class="n-news-list__title">{{ item.title }}</h3>
												<p class="n-news-list__description"></p>
												<span class="n-news-list__tag">{{ item.tag }}</span>
											</div>
											<a class="link-full-block" :href="item.url"></a>
										</div>
									</div>
								</template>
							</template>
						</div>
						<a
							class="button button_type_secondary button_full text-center n-mt-3"
							href="/media/news/search/"
							>Все новости</a
						>
					</div>
				</div>
				<div class="n-col-lg-12 mass-media-block__container">
					<!-- СМИ -->
					<div
						class="mass-media-block mass-media-citrix-block n-pt-lg-3"
						v-if="dataSmi"
					>
						<div class="mass-media-block__wrap">
							<h3 class="mass-media-block__header" title="СМИ о нас">
								СМИ о нас
							</h3>
							<div class="news-main-flex-wrapper lg-hidden">
								<div class="news-main-flex-wrapper__item">
									<ul class="mass-media-block__list">
										<template
											v-for="(item, index) in JSON.parse(dataSmi).items"
											:key="index"
										>
											<li class="mass-media-block__item">
												<a
													class="mass-media-block__item-link"
													:href="item.url"
													target="_blank"
												>
													<img
														class="mass-media-block__publisher"
														:src="item.imgSrc"
														:alt="item.title"
													/>

													<time
														class="mass-media-block__date"
														:datetime="item.date"
														>{{ item.time }}</time
													>

													<p class="mass-media-block__title">
														{{ item.title }}
													</p>
												</a>
											</li>
										</template>
									</ul>

									<a
										class="mass-media-citrix__button button button_type_secondary mw-100 text-center"
										href="/media/smi/"
										title="Все новости СМИ"
									>
										Все новости СМИ
									</a>
								</div>
							</div>
						</div>
					</div>
					<!-- Аукционы -->
					<div
						class="news-main-flex-wrapper__item news-main-flex-wrapper__item--telegram"
						v-if="dataAuction"
					>
						<div class="mass-media-block__list-wrap">
							<div>
								<h3 class="mass-media-block__header" title="Новости аукционов">
									Новости аукционов
								</h3>
								<ul
									class="mass-media-block__list mass-media-block__list--auction"
								>
									<template
										v-for="(item, index) in JSON.parse(this.dataAuction).items"
										:key="index"
									>
										<li class="mass-media-block__item">
											<a
												class="mass-media-block__item-link"
												:href="item.url"
												target="_blank"
											>
												<time
													class="mass-media-block__date"
													:datetime="item.date"
													>{{ item.time }}</time
												>
												<p class="mass-media-block__title">{{ item.title }}</p>
											</a>
										</li>
									</template>
								</ul>
							</div>
							<a
								class="mass-media-citrix__button button button_type_secondary mw-100 text-center"
								href="/media/news/search/?tag_slug=Аукционы"
								title="Все новости аукционов"
							>
								Все новости аукционов
							</a>
						</div>
						<div class="channel-widget">
							<div class="channel-widget__qr">
								<picture class="channel-widget__pic">
									<source
										media="(max-width: 767px)"
										srcset="
											/static/v2/src/img/media/news/tg_qr_mobile.webp    1x,
											/static/v2/src/img/media/news/tg_qr_mobile@2x.webp 2x
										"
										type="image/webp"
									/>
									<source
										media="(max-width: 1124px)"
										srcset="
											/static/v2/src/img/media/news/tg_qr_tablet.webp    1x,
											/static/v2/src/img/media/news/tg_qr_tablet@2x.webp 2x
										"
										type="image/webp"
									/>
									<source
										media="(max-width: 1399px)"
										srcset="/static/v2/src/img/media/news/tg_qr@3x.webp"
										type="image/webp"
									/>
									<source
										srcset="
											/static/v2/src/img/media/news/tg_qr.webp    1x,
											/static/v2/src/img/media/news/tg_qr@2x.webp 2x
										"
										type="image/webp"
									/>
									<img
										width="302"
										height="232"
										class="channel-widget__img"
										src="/static/v2/src/img/media/news/tg_qr.webp"
										alt="Подпишитесь на наш Телеграм канал и будьте в курсе последних новостей"
										loading="lazy"
									/>
								</picture>
							</div>
							<div class="channel-widget__content">
								<h3 class="channel-widget__title h4-semibold">
									Подпишитесь на&nbsp;наш Телеграм канал и&nbsp;будьте
									в&nbsp;курсе последних новостей
								</h3>
								<custom-button
									href="https://t.me/domrf_life"
									label="Подписаться"
									color-theme="dark"
									type="secondary"
									target="_blank"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="black-section section-wrapper">
		<div class="c-wrap grid-wrapper">
			<div class="section-wrapper__title">
				<h2 class="page-subtitle d-block n-mb-2 n-mb-md-3">Фото и видео</h2>
			</div>
			<div class="grid-wrapper__link n-mt-3 n-mt-lg-0">
				<a
					class="button button_type_secondary is-filled n-mb-lg-3 n-mb-0"
					href="/media/medialibrary/"
					>Все медиаматериалы</a
				>
			</div>
			<div class="grid-wrapper__content" v-if="dataMedialibrary">
				<div class="n-row n-mb-n2">
					<template
						v-for="(item, index) in JSON.parse(this.dataMedialibrary).items"
						:key="index"
					>
						<div class="n-col-24 n-col-md-12 n-col-lg-8 n-mb-2">
							<a class="media-block" :href="item.url">
								<div class="media-block__cover">
									<div class="media-block__overlay">
										<span
											class="media-block__count"
											v-if="item.type === 'photo'"
											>{{ item.count }} фото</span
										>

										<img
											:class="
												item.type === 'video'
													? 'media-block__video-play'
													: 'media-block__media-icon'
											"
											:src="
												item.type === 'video'
													? '/static/dist/v2/img/icon-play.svg'
													: '/static/dist/v2/img/icon-photos.svg'
											"
											:alt="item.title"
										/>
									</div>
									<img
										class="media-block__image"
										:src="item.imageSrc"
										:alt="item.title"
									/>
								</div>
								<div class="media-block__content">
									<time class="media-block__date" :datetime="item.data">{{
										item.data
									}}</time>
									<p class="media-block__title">{{ item.title }}</p>
								</div>
							</a>
						</div>
					</template>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import axios from 'axios'
import CustomButton from '@/js/storybook/Button.vue'
import marquee from '../../modules/marquee'
import newsMainSearch from '../../modules/news-main-search'
import searchInputs from '../../modules/search-inputs'
export default {
	name: 'NewsMainPage',
	components: { CustomButton },
	props: [
		'data',
		'dataLastOneId',
		'dataSmi',
		'dataAuction',
		'dataMedialibrary',
	],
	data() {
		return {
			marque: [],
		}
	},
	methods: {
		async getMarqueData() {
			try {
				const { data } = await axios.get('/api/public/content/media/marquee/')
				this.marque = data.data
			} catch (e) {
				console.log(e.message)
			}
		},
	},
	mounted() {
		this.getMarqueData()
	},
	updated() {
		marquee()
		newsMainSearch()
		searchInputs()
	},
}
</script>
